import { CaretRightIcon, CircleNotchIcon } from '@phosphor-icons/react';
import type { EventAdminRsvpCardProps } from '@/lib/types/events.types';
import { EventDetailsContent } from '@/content/EventDetailsContent';
import { ActionCard } from '@/components/ui/ActionCard';

export function EventAdminRsvpCard({
  goingCount,
  onViewList,
  isLoading = false,
}: EventAdminRsvpCardProps) {
  const title = isLoading ? (
    <CircleNotchIcon size={20} weight="bold" className="animate-spin" />
  ) : (
    `${goingCount} ${EventDetailsContent.adminRsvpCard.countLabel}`
  );

  return (
    <ActionCard
      data-testid="admin-rsvp-card"
      title={title}
      subtext={EventDetailsContent.adminRsvpCard.viewListCta}
      icon={CaretRightIcon}
      hasBadge={true}
      badgeColor="green"
      onClickAction={onViewList}
      className="bg-slate-700 mt-4"
    />
  );
}
